// B1.4: HR positions, role permissions, custom roles (move-only from client.ts).
import { ApiClientCore, buildQueryString } from './http/core';

export class HrPositionsApi extends ApiClientCore {
  // ─── Positions ──────────────────────────────────────────────────────────────
  async getPositions(params: Record<string, any> = {}): Promise<any> {
    return this.get(`/api/v1/positions${buildQueryString(params)}`);
  }
  async getPosition(id: number): Promise<any> {
    return this.get(`/api/v1/positions/${id}`);
  }
  async getPositionStats(): Promise<any> {
    return this.get('/api/v1/positions/stats');
  }
  async createPosition(data: any): Promise<any> {
    return this.post('/api/v1/positions', data);
  }
  async updatePosition(id: number, data: any): Promise<any> {
    return this.put(`/api/v1/positions/${id}`, data);
  }
  async deletePosition(id: number): Promise<any> {
    return this.delete(`/api/v1/positions/${id}`);
  }
  async getRolePermissions(): Promise<any> {
    return this.get('/api/v1/permissions/roles');
  }
  async updateRolePermissions(role: string, modules: Record<string, any>): Promise<any> {
    return this.put(`/api/v1/permissions/roles/${role}`, { modules });
  }
  // ─── Custom role templates (reserved; API may return 410 / empty list until re-enabled) ───
  async getCustomRoles(): Promise<any> {
    return this.get('/api/v1/roles');
  }
  async createCustomRole(data: any): Promise<any> {
    return this.post('/api/v1/roles', data);
  }
  async updateCustomRole(id: number, data: any): Promise<any> {
    return this.put(`/api/v1/roles/${id}`, data);
  }
  async deleteCustomRole(id: number): Promise<any> {
    return this.delete(`/api/v1/roles/${id}`);
  }
  async getCustomRoleUsers(id: number): Promise<any[]> {
    return this.get(`/api/v1/roles/${id}/users`);
  }
  async delegateRequestRole(
    requestId: number,
    data: {
      from_user_id: number;
      to_user_id: number;
      role: string;
      permissions: Record<string, boolean>;
      valid_until?: string;
    }
  ): Promise<any> {
    return this.post(`/api/v1/consumables/requests/${requestId}/delegate`, data);
  }
  async getMyRequestPermissions(requestId: number): Promise<any> {
    return this.get(`/api/v1/consumables/requests/${requestId}/my-permissions`);
  }
  async getPositionEmployees(id: number): Promise<any> {
    return this.get(`/api/v1/positions/${id}/employees`);
  }
}
